import DataSourceMngContext from "./DataSourceMngContext";
import useDataSourceMng from "./useDataSource";

function DataSourceMngProvider(props) {
    const ctx = useDataSourceMng();
    return (
        <DataSourceMngContext.Provider value={ctx}>
            {props.children}
        </DataSourceMngContext.Provider>
    )
}



export default DataSourceMngProvider;